import React, { memo } from 'react'

function TextWidget({editFlag, wid, data, openCallback, deleteCallback}) {
    const body = data?.body || ''
    const background = Boolean(data?.background)
    // The "Transparent background" flag always wins: a custom card color only
    // applies when the widget isn't set to transparent, so existing
    // transparent widgets keep looking exactly as before.
    const cardBackgroundColor = background ? 'transparent' : (data?.backgroundColor || '#ffffff')

  return (
    <div style={{backgroundColor: cardBackgroundColor, boxShadow: (background) ? 'none': ''}} className='dwidget-container'>
        {/* <div className='d-flex justify-content-end'>
        
            <div>
                <i style={{color: '#808080', cursor: 'pointer'}} className="fa-regular fa-pen-to-square"></i>
                <i style={{color: '#808080', cursor: 'pointer'}} className="fa-regular fa-circle-xmark px-2 pt-2"></i>
            </div>
        </div>   */}
        <div style={{position: 'relative'}} className='h-100'>
            {editFlag && (
                <div style={{position: 'absolute', right: '0'}}>
                    <i onMouseDown={e => openCallback(wid, data)} style={{color: '#808080', cursor: 'pointer'}} className="fa-regular fa-pen-to-square"></i>
                    <i onMouseDown={e => deleteCallback(wid)} style={{color: '#808080', cursor: 'pointer'}} className="fa-regular fa-circle-xmark px-2 pt-2"></i>
                </div>
            )}
            <div className='d-flex justify-content-center align-items-center h-100'>
                {body ? (
                    <div dangerouslySetInnerHTML={{ __html: body }} />
                ): (
                    <div onMouseDown={editFlag ? () => openCallback?.(wid, data) : undefined} style={{color: '#8b8b8b', cursor: editFlag ? 'pointer' : 'default'}} className='text-center'>
                        {editFlag ? <>Click edit button <br />to edit the text</> : 'No content available.'}
                        
                        {/* {editFlag && (
                            <i  style={{color: '#808080', cursor: 'pointer'}} className="fa-regular fa-pen-to-square"></i>
                        )} */}
                    </div>
                )}
            </div>
        </div>
      
    

    </div>
  )
}

export default memo(TextWidget)
